(() => {
  const stateKey = '__menoplayPdpFaqAccordionController';
  window[stateKey]?.abort();

  const controller = new AbortController();
  window[stateKey] = controller;

  document.addEventListener('toggle', (event) => {
    const item = event.target;
    if (!(item instanceof HTMLDetailsElement) || !item.open || !item.matches('.menoplay-pdp-faq-item')) return;

    const list = item.closest('.menoplay-pdp-faq-list');
    if (!list?.closest('[data-menoplay-pdp-module="faq"]')) return;

    list.querySelectorAll('.menoplay-pdp-faq-item[open]').forEach((sibling) => {
      if (sibling !== item) sibling.open = false;
    });
  }, { capture: true, signal: controller.signal });
})();
